export default __webpack_public_path__ + "media/images/svg/phone-hand-icon-62fabd94c6fb3e4048ce046e62b95e86.svg";